















































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/porposal/porposal.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/porposal.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { ProposalState } from "@/enums/ProposalState";
import { ProjectState } from "../../enums/projectState";
import Porposal from "@/models/porposal/porposal.model";
import ProposalDisbursement from "@/models/porposal/proposalDisbursement.model";
import PorposalService from "../../services/porposal.service";
import searcherService from "@/services/searcher.service";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import fileService from "@/services/file.service";

@Component({
  components: {
    ResearchCenterBasicInformationComponent
  }
})
export default class ApprovalProjectsTableComponent extends GenericBTable<Porposal> {
  annoucementId = null;
  codes = "";
  code = "";
  loading = false;

  created() {
    this.tableConfig.controller = `Porposal/GetProjectInProgressByResearchCenter`;
    this.formatColumns();
  }

  @Watch("annoucementId")
  getByAnnoucement() {
    this.tableConfig.whereParams = `annoucementId eq  ${this.annoucementId}`;
    this.tableConfig.reload();
  }
  @Watch("code")
  getByCode() {
    this.tableConfig.whereParams = `contains(Code, '${this.code}')`;
    this.tableConfig.reload();
  }
  searchByCode(event: any) {
    if (event.keyCode === 13) {
      this.code = this.codes.trim();
    }
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.project", true);
    name.customTemplate = true;

    let researchCenter = new BTableColumn(
      "researchCenter",
      "table.researchCenter",
      true
    );
    researchCenter.customTemplate = true;

    this.tableConfig.insertColumns(name, researchCenter);

    this.tableConfig.actions.customTemplate = true;
    this.tableConfig.enableDefaultColumns = false;
  }

  public verOpciones(row: Porposal) {
    this.$router.push(`/convocatoria/propuesta/${row.id}/detail`);
  }
}
